import { GenericDatabase } from './GenericDatabase'

const DB_NAME = 'ReportesListos'
const DB_VERSION = 1
const STORE_NAME = 'reportesListos'

const dbInstance = new GenericDatabase(DB_NAME, DB_VERSION, [
    { name: STORE_NAME, keyPath: 'idIndex' }
])

const initDb = () => {
    return dbInstance.init()
}

const agregar = (data, database) => {
    return dbInstance.add(STORE_NAME, data, database)
}

const obtener = (clave, database) => {
    return dbInstance.get(STORE_NAME, Number(clave), database)
}

const consultarPorDato = (dato, database) => {
    // Original was empty, just opened cursor and did nothing.
    // Return null as placeholder.
    return new Promise(resolve => resolve(null))
}

const actualizar = (data, database) => {
    return dbInstance.put(STORE_NAME, data, database)
}

const eliminar = (clave, database) => {
    return dbInstance.delete(STORE_NAME, Number(clave), database)
}

const consultar = (database) => {
    return dbInstance.getAll(STORE_NAME, database)
}

export default {
    initDb,
    agregar,
    obtener,
    actualizar,
    eliminar,
    consultar,
    consultarPorDato
}
